import React from 'react';
import { motion } from 'framer-motion';
export function Introduction() {
  return <section className="py-24 md:py-32 bg-white px-6" data-id="element-200">
      <div className="max-w-4xl mx-auto text-center" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center" data-id="element-202">
          <div className="w-px h-16 bg-gold mb-8" data-id="element-203"></div>

          <h2 className="text-3xl md:text-5xl font-serif text-charcoal mb-8 leading-tight" data-id="element-204">
            Elevating the Standard of <br data-id="element-205" />
            <span className="italic text-gold" data-id="element-206">Luxury Real Estate</span>
          </h2>

          <p className="text-lg md:text-xl text-charcoal-light font-light leading-relaxed max-w-3xl" data-id="element-207">
            As Las Vegas's premier luxury real estate destination, we specialize
            in curating an exclusive portfolio of the city's most magnificent
            properties. From sprawling desert estates to sophisticated high-rise
            penthouses, we provide an unparalleled level of service and
            discretion for our discerning clientele.
          </p>

          <div className="w-px h-16 bg-gold mt-12" data-id="element-208"></div>
        </motion.div>
      </div>
    </section>;
}